const products = {
	add_button: "Product toevoegen",
	alerts: {
		product_added: "Product <strong>{{name}}</strong> succesvol toegevoegd!",
		product_edited: "Product <strong>{{name}}</strong> succesvol gewijzigd!",
	},
	delete_dialog: {
		description: "Wilt u product <strong>{{name}}</strong> echt verwijderen?",
		success_alert: "Verwijderen van product is gelukt!",
		title: "Product verwijderen",
		unknown_alert: "Verwijderen van product is niet gelukt! Probeert u het later opnieuw.",
	},
	disconnect_dialog: {
		description:
			"Wilt u domein <strong>{{name}}</strong> echt verwijderen uit product groep <strong>{{product_group}}</strong>?",
		success_alert: "Verwijderen van domein is gelukt!",
		title: "Domein ontkoppelen",
		unknown_alert: "Verwijderen van domein is niet gelukt! Probeert u het later opnieuw.",
	},
	errors: {
		invalid_price_calculation: "Ongeldige prijsberekening",
		invalid_test_formula_calculation:
			"Error: niet alle variabelen zijn ingevuld of de formule is incorrect",
		missing_required_variables: "Error: q en pr variabelen moeten aanwezig zijn in de formule.",
	},
	product_add: {
		form: {
			description: "Omschrijving",
			formula: "Formule",
			formula_check: "Maakt gebruik van een formule",
			formula_helper: `De waarden 'q' (Aantal) & 'pr' (Adviesprijs) zijn verplichte waarden. Deze moeten dus worden gebruikt in de formule. De waarde 'pp' (Inkoopprijs) is optioneel.

														<strong>Geaccepteerde operators zijn:</strong>
															+	(optellen)
															-	(aftrekken)
															*	(vermenigvuldigen)
															/	(delen)
															%	(modulus)
															** (exponent)
															() (haakjes om expressies te groeperen)`,
			name_de: "Product naam (Duits)",
			name_en: "Product naam (Engels)",
			name_nl: "Productnaam",
			per: "Per",
			price_purchase: "Inkoopprijs",
			price_recommended: "Adviesprijs",
			product_code: "Product code",
			product_code_invalid: "Er is geen Hostfact product gevonden met bovenstaande code",
			product_groups: "Productgroepen",
			product_number: "HostFact product nummer",
			quantity: "Aantal",
			test_your_formula: {
				price: "Prijs",
				result: "Resultaat:",
				title: "Test uw formule:",
			},
			unit: "Eenheid",
		},
		section_description: "Met behulp van dit formulier kunt u een nieuw product aanmaken.",
		section_title: "Product toevoegen",
		title: "Product toevoegen",
	},
	product_edit: {
		section_description: "Met behulp van dit formulier kunt u het geselecteerde product bewerken.",
		section_title: "Product bewerken",
		title: "Product bewerken",
	},
	table: {
		filters: {
			disabled: "Toon verwijderde producten",
		},
		headers: {
			cost: "Kostprijs",
			description: "Omschrijving",
			formula: "Formule",
			hostfact_number: "Hostfact nummer",
			price: "Adviesprijs",
			product_code: "Product code",
			product_group: "Product groep",
			product_name: "Product naam",
			sell_unit: "Verkoopeenheid",
		},
	},
	title: "Producten",
};

export default products;
